<div mat-dialog-title>@if (isAddMode) {
  <span>Add Labels</span>
  }@if (!isAddMode) {
  <span>Remove Labels</span>
  }<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
  <mat-dialog-content>
    @if (isAddMode && isSingleMode) {
      <div class="block">Select labels to be added to this portfolio.</div>
    }
    @if (!isAddMode && isSingleMode) {
      <div class="block">Select labels to be removed from this portfolio.</div>
    }
    @if (isAddMode && !isSingleMode) {
      <div class="block">Select labels to be added to these portfolios.</div>
    }
    @if (!isAddMode && !isSingleMode) {
      <div class="block">Select labels to be removed from these portfolios.</div>
    }
    <div><irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "gridHeight"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      noRowsOverlayComponent = "DialogPortfolioCustomLabelsModifyNoRowComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
      [frameworkComponents] = 'gridOptions.frameworkComponents'
      [rowData] = 'data'
      (gridReady) = "onGridReady($event)"
    [footerContent]="footerContent"></irb-inventory-grid></div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button (click)="close()" class="btn-medium-secondary">Cancel</button>
    @if (isAddMode) {
      <button (click)="callFinishButtonCallback()" class="btn-medium-primary" [disabled]="totalSelectCount === 0">Add Labels</button>
    }
    @if (!isAddMode) {
      <button (click)="callFinishButtonCallback()" class="btn-medium-primary" [disabled]="totalSelectCount === 0">Remove Labels</button>
    }
  </mat-dialog-actions>
